import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import cn from 'classnames';
import Hint from "../../components/Hint/Hint";
import WithPlaceholder from '../../hoc/WithPlaceholder';



class OFFChecksCashedModal extends Component {
  state = {
    data: {
      contestName: 'off-checks'
    }
  };

  onChange = e => {
    const target = e.target;

    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      }
    }));
    
    if (this.props.error) {
      this.setState(this.props.error = '')
    };
  };

  handleSubmit = e => {
    e.preventDefault();
    const data = new FormData(e.target);
    this.props.sendData(data);
  };
  
  render() {
    const { isOpen, toggleModal, error, isLoading} = this.props;
    const { count } = this.state;

    return (
      <Modal className='modal-offchecks' isOpen={isOpen} toggle={toggleModal} centered autoFocus>
        <ModalHeader toggle={toggleModal}>
          <FormattedMessage id="offcheck.modal.header" defaultMessage="Cashing OFF-checks" />
        </ModalHeader>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <ModalBody className="py-4">
            <p className="form-text">
              <FormattedMessage id="offcheck.modal.text" defaultMessage="To participate in the motorcycle drawing and 500,000 rubles, you need to cash the OFF-checks." />
            </p>
            <Input
                name="contestName"
                id="contestName"
                value='off-checks'
                type="hidden"
            />
            <FormGroup className={cn('no-margin', { ['has-error']: error })} row>
              <Label htmlFor="count">
                <FormattedMessage id="offcheck.modal.label" defaultMessage="How many OFF-checks do you want to cash out?" />
              </Label>
              <WithPlaceholder
                name="count"
                id="offchecks_count"
                onChange={this.onChange}
                value={count}
                placeholder="offcheck.modal.input.placeholder"
                maxLength={10}
                type="number"
                autoFocus
                required
              />
              <Hint
                  id={'offcheck-modal-tooltip'}
                  text={
                    <FormattedMessage
                        id={`offcheck.modal.tooltip.hint`}
                        defaultMessage="Enter the number of OFF-checks"
                    />
                  }
              />
              {error && <small className="form-text">{error}</small>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={isLoading}>
              {isLoading ? (
                <span className="loading-spinner loading-spinner-btn" />
              ) : (
                <FormattedMessage id="offcheck.modal.button" defaultMessage="Cashed" />
              )}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default OFFChecksCashedModal;
